"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetListFilterMap = exports.datasetListSortMap = void 0;
exports.datasetListSortMap = {
    id: "c.id",
    name: "c.name",
    fileType: "dsd.file_type",
    datasetType: "dsd.dataset_type",
    fileCount: "fileCount",
    createdAt: "c.date_created",
    updatedAt: "c.date_modified",
    dataSources: "dsd2.provider",
};
exports.datasetListFilterMap = {
    id: "c.id",
    name: "c.name",
    fileType: "dsd.file_type",
    datasetType: "dsd.dataset_type",
    fileCount: "c.fileCount",
    createdAt: "c.date_created",
    updatedAt: "c.date_modified",
    dataSources: "dsd2.provider",
};
